<template>
	<div class="component-new">
		<FunctionTitle :title="mainTitle" />
		<CommonFlame :title="title">
			<v-alert v-for="(error, i) in errors" :key="i" border="top" color="red lighten-2" dark>
				{{ error }}
			</v-alert>
			<ComponentForm :component_data.sync="component">
				<template v-slot:submit-btn>
					<v-row no-gutters class="mt-4" justify="center">
						<v-btn color="secondary" :disabled="!isValid" @click="createComponent">
							<v-icon class="mr-1">mdi-plus</v-icon> 追加する
						</v-btn>
					</v-row>
				</template>
			</ComponentForm>
		</CommonFlame>
	</div>
</template>

<script>
import axios from "axios"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"

import CommonFlame from "../shared/CommonFlame.vue"
import FunctionTitle from "../shared/FunctionTitle.vue"
import ComponentForm from "./ComponentForm.vue"
export default {
	components: {
		CommonFlame,
		FunctionTitle,
		ComponentForm,
	},
	data() {
		return {
			mainTitle: "部品",
			title: "部品作成",
			component: {
				name: "",
				part_number: "",
				description: "",
				stock: null,
				unit_price: null,
				wildcard: false,
			},
			errors: [],
		}
	},
	mounted() {
		authenticate.authenticateUser()
	},
	methods: {
		createComponent() {
			const headers = authenticate.setHeader()
			axios
				.post(
					"/erp/v1/components",
					{
						component: {
							name: this.component.name,
							part_number: this.component.part_number,
							unit_price: this.component.unit_price,
							stock: this.component.stock,

							description: this.component.description,
							wildcard: this.component.wildcard,
						},
					},
					{
						headers,
					}
				)
				.then((res) => {
					this.$store.commit("setFlash", {
						type: "notice",
						text: "部品を登録しました。",
					})
					this.$router.push({ name: "component_index" })
				})
				.catch((err) => {
					const errors = errorHandling.errorResponse(err)
					if (Array.isArray(errors)) {
						this.errors = errors
					}
				})
		},
		isPresence(value) {
			return value !== null && value !== ""
		},
	},
	computed: {
		isValid() {
			if (this.isPresence(this.component.name) && this.isPresence(this.component.part_number)) {
				return true
			} else {
				return false
			}
		},
	},
}
</script>

<style lang="scss" scoped>
.main-body {
	display: block !important;
	width: 70%;
	margin: 0 auto;
}
.component-new {
	.form {
		@media (min-width: 795px) {
			padding: 10px 57px;
		}
		&--center {
			text-align: center;
		}
	}
}
</style>
